<template>
  <card class="card">
    <!--------------------------------QR Option Row  Start--------------------------------->
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-4 border-bottom border-dark text-center">
        <div id="canvas"></div>
        <!-- Preview link and Copy button -->

      </div>
      <div class="col-md-2 col-lg-2 col-sm-2 mt-2">
        <div class="example square">
          <p>{{ $t('qrOptions.backgroundColor') }}</p>
          <input id="backColor" type="text" class="coloris instance1 form-control" v-model="backColor">
        </div>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-2 mt-2">
        <div class="example square">
          <p>{{ $t('qrOptions.dotColor') }}</p>
          <input id="dotColor" type="text" class="coloris instance1 form-control" v-model="dotColor">
        </div>
      </div>
<!--      <div class="col-md-4 col-lg-4 col-sm-4 mt-2">-->
<!--        <div class="row">-->
<!--          <div class="example square col-8">-->
<!--            <p>{{ $t('qrOptions.image') }}</p>-->
<!--            <input v-if="!qrImage" type="file" class="form-control" @change="handleImageChange" accept=".jpg, .png, .jpeg"/>-->
<!--            <p v-if="qrImage" style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{qrImage}}</p>-->
<!--          </div>-->
<!--          <div class="example square col-1">-->
<!--            <br>-->
<!--            <br>-->
<!--            <p-button type="danger" round @click.native.prevent="removeImage" class="text-center ti-trash"></p-button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <!--------------------------------QR Option Row End --------------------------------->

    <!--------------------------------Button Start--------------------------------->
    <div class="btn-toolbar float-right mt-2">
      <div class="btn-group mr-2 text-right">
        <p-button type="info" round @click.native.prevent="openModal">
          {{ $t('buttons.downloadQR') }}
        </p-button>
      </div>
      <div class="btn-group text-right">
        <p-button type="info" round @click.native.prevent="updateQrInfo">
          {{ $t('buttons.updateQR') }}
        </p-button>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <input type="text" class="form-control" :value="qrData" readonly>
      </div>
      <div class="col-2">
        <button class="btn btn-primary" @click="copyToClipboard(qrData)">
          {{ $t('qrOptions.buttonCopy') }}
        </button>
      </div>
    </div>
    <!--------------------------------Button End--------------------------------->

    <!--------------------------------Modal Start--------------------------------->
    <div class="modal">
      <div class="modal-content">
        <span class="close " @click="closeModal">&times;</span>
        <div class="text-center">
          <div class="row mt-5">
            <div class="col-md-4">
              <fg-input
                type="number"
                :label="$t('modal.width')"
                placeholder="250"
                v-model="qrWidth"
              >
              </fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="number"
                :label="$t('modal.height')"
                placeholder="250"
                v-model="qrHeight"
              >
              </fg-input>
            </div>
            <div class="col-md-3">
              <label class="control-label">
                {{ $t('modal.qrType') }}
              </label>
              <div class="form-control">
                <select v-model="qrType" aria-label="QR Type">
                  <option value="svg" selected>SVG</option>
                  <option value="png">PNG</option>
                </select>
              </div>
            </div>
          </div>
          <p-button type="info" round @click.native.prevent="downloadQr">
            {{ $t('buttons.download') }}
          </p-button>
        </div>
      </div>
    </div>
    <!--------------------------------Modal End--------------------------------->
  </card>
</template>

<script>
import axios from "axios";
import config from "@/routing_map.json";
import router from "@/router";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import "@/plugins/coloris/coloris.min.js"
import "@/plugins/qr-code-styling"
import "@/plugins/coloris/coloris.min.css"

export default {

  data() {
    return {
      title: "QR Info",
      dotColor: "rgb(37,117,225)",
      backColor: "rgb(255, 255, 255)",
      qrCode: null,
      qrImage: null,
      qrImageSrc: null,
      qrWidth: 250,
      qrHeight: 250,
      qrType: 'svg',
      qrData: "https://onlinecardvisit.com", // QR preview data
      modal: false,
      imagePreview: false,
    };
  },
  watch: {
    dotColor() {
      this.createQr();
    },
    backColor() {
      this.createQr();
    },
    qrImage(newValue, oldValue) {
      if (!this.imagePreview && (newValue !== oldValue)) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.qrImageSrc = value;
              this.createQr();
            })
            .catch(() => {
              this.qrImageSrc = null;
              this.createQr();
            });
        } else {
          this.qrImageSrc = null;
          this.createQr();
        }
      }
    },
  },
  mounted() {
    this.getUser();
    setTimeout(() => {
      this.createQr();
      this.initColoris();
    }, 500);
  },

  methods: {
    closeModal() {
      document.querySelector('.modal').style.display = 'none';
    },
    openModal() {
      document.querySelector('.modal').style.display = 'block';
    },
    downloadQr() {
      let app_data = this;
      this.createQr();
      setTimeout(function () {
        app_data.qrCode.download({ name: "qr", extension: app_data.qrType });
      }, 500);
      setTimeout(() => {
        app_data.qrWidth = 250;
        app_data.qrHeight = 250;
        app_data.createQr();
        document.querySelector('.modal').style.display = 'block';
      }, 1000);
    },
    handleImageChange(event) {
      this.imagePreview = false;
      this.qrImage = null;
      this.qrImage = event.target.files[0];
    },
    removeImage() {
      this.qrImage = null;
      this.qrImageSrc = null;
      this.createQr();
    },
    initColoris() {
      Coloris({
        el: '.coloris',
        swatches: [
          '#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51', '#d62828', '#023e8a',
          '#0077b6', '#0096c7', '#00b4d8', '#48cae4'
        ]
      });

      Coloris.setInstance('.instance1', {
        theme: 'pill',
        themeMode: 'dark',
        formatToggle: true,
        closeButton: true,
        clearButton: true,
        swatches: ['#067bc2', '#84bcda', '#80e377', '#ecc30b', '#f37748', '#d56062']
      });
    },
    updateQrInfo() {
      const app_data = this;
      let qrInfo = {
        dotColor: app_data.dotColor,
        backColor: app_data.backColor,
        qrImage: app_data.qrImage,
        qrData: app_data.qrData,
      };
      const form = new FormData();
      form.append('qr_image', app_data.qrImage);
      form.append('qr_info', JSON.stringify(qrInfo));

      axios.defaults.headers.common.authorization = localStorage.getItem('authorization');
      axios.post(
        `${config.app_url}/user/update-user-qr/?userHash=${JSON.parse(localStorage.getItem('userInfo')).userHash}`,
        form
      ).then(response => {
        if (response.data.success) {
          router.push('edit-qr');
          app_data.notifyVue('top', 'right', "Güncelleme Başarılı!", "success");
        } else {
          app_data.notifyVue('top', 'right', "Güncelleme Başarısız!", "warning");
        }
      }).catch(() => {
        app_data.notifyVue('top', 'right', "Bağlantı Hatası!", "warning");
      });
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        duration: 2000,
      });
    },
    getUser() {
      const app_data = this;
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization');
      axios.get(`${config.app_url}/user/get-user`).then(response => {
        if (response.data.success) {
          if (response.data.msg.qr_info) {
            if (response.data.msg.qr_info.dotColor) app_data.dotColor = response.data.msg.qr_info.dotColor;
            if (app_data.backColor) app_data.backColor = response.data.msg.qr_info.backColor;
            if (response.data.msg.qr_info.qrImage) app_data.qrImage = response.data.msg.qr_info.qrImage;
            if (response.data.msg.qr_info.qrImage) app_data.qrImageSrc = `${config.img_url}/${response.data.msg.qr_info.qrImage}`;
            if (response.data.msg.qr_info.qrData) app_data.qrData = `${config.qr_url}/qr-user/?hash=${response.data.msg.userHash}`;
          }
          app_data.imagePreview = true;
        } else {
          app_data.notifyVue('top', 'right', "Bağlantı Hatası!", "warning");
        }
      }).catch(() => {
        app_data.notifyVue('top', 'right', "Bağlantı Hatası!", "warning");
      });
    },
    createQr() {
      this.qrCode = new QRCodeStyling({
        width: this.qrWidth,
        height: this.qrHeight,
        type: this.qrType,
        data: this.qrData,
        image: this.qrImageSrc,
        dotsOptions: {
          color: this.dotColor,
          type: "rounded",
        },
        backgroundOptions: {
          color: this.backColor,
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 10,
        },
      });

      document.getElementById("canvas").innerHTML = "";
      this.qrCode.append(document.getElementById("canvas"));
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.notifyVue('top', 'right', "Link Kopyalandı!", "success");
      });
    }
  },
};
const base64Encode = (data) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(data);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
</script>

<style scoped>
@import '/src/plugins/coloris/coloris.min.css';

/*modal*/
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background-color: #fff;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 5px;
  position: relative;
  animation: slide-down 0.5s;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

@keyframes slide-down {
  from {
    transform: translateY(-50%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/*copy to clipboard and preview section*/
.row input.form-control {
  width: 100%;
  margin-right: 5px;
}

.btn.btn-primary {
  margin-left: 5px;
}
</style>
